module.exports = __webpack_public_path__ + "static/media/car-crash.870299ac.svg";